import http from "./httpservices";
import GetCookieByName from "../../hooks/GetCookie";

const endPoint = "filter/influencers";

function getAuthToken() {
  try {
    const raw = GetCookieByName("auth");
    if (typeof raw !== "string") return undefined;
    return JSON.parse(raw)["token"];
  } catch {
    return undefined;
  }
}

export async function FetchInfluencers(filter, sorting, page, isContacts) {
  return http.get(`${endPoint}/filters`, {
    params: { filter, sorting, page, isContacts },
    headers: { "x-auth-token": getAuthToken() },
  });
}

export async function FetchInfluencersCount(filter, isContacts, engagedCreators) {
  return http.get(`${endPoint}/count`, {
    params: { filter, isContacts, engagedCreators },
    headers: { "x-auth-token": getAuthToken() },
  });
}

export async function FetchCategories() {
  return http.get(`${endPoint}/categories`, {
    headers: { "x-auth-token": getAuthToken() },
  });
}

export async function FetchStates() {
  return http.get(`${endPoint}/states`, {
    headers: { "x-auth-token": getAuthToken() },
  });
}

export async function FilteredInfluencers(filter, sorting, page, isContacts, nextCursor, engagedCreators, engagedSort = 'followers') {
  let params = {
    filter,
    sorting,
    page,
    isContacts,
    engagedCreators,
    engagedSort,
  };

  if (nextCursor) {
    // Cursor key differs by sort: engagement uses cursorCampaigns, followers uses cursorFollowers.
    if (engagedSort === 'engagement' && nextCursor.campaigns != null) {
      params.cursorCampaigns = nextCursor.campaigns;
    } else if (nextCursor.followers != null) {
      params.cursorFollowers = nextCursor.followers;
    }
    params.cursorId = nextCursor.id;
  }

  return http.get(`${endPoint}/based-on-followers`, {
    params,
    headers: { "x-auth-token": getAuthToken() },
  });
}

export default {
  FetchInfluencers,
  FetchInfluencersCount,
  FetchCategories,
  FetchStates,
  FilteredInfluencers,
};
